import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { UserOutlined } from "@ant-design/icons";
import { Avatar, Popover } from "antd";

type Props = {
  actorText: string;
  avatarLabel: string;
  hasProfile: boolean;
  content: React.ReactNode;
  portalSelector?: string;
};

/** AccountConnect 的纯呈现层；不拥有账号、扫码、token 或断开状态。 */
const AccountMenuTrigger: React.FC<Props> = ({
  actorText,
  avatarLabel,
  hasProfile,
  content,
  portalSelector,
}) => {
  const [portalTarget, setPortalTarget] = useState<HTMLElement | null>(null);

  useEffect(() => {
    if (!portalSelector) {
      setPortalTarget(null);
      return;
    }
    const syncTarget = () => {
      const next = document.querySelector<HTMLElement>(portalSelector);
      setPortalTarget((current) => (current === next ? current : next));
    };
    syncTarget();
    const observer = new MutationObserver(syncTarget);
    observer.observe(document.body, { childList: true, subtree: true });
    return () => observer.disconnect();
  }, [portalSelector]);

  const trigger = (
    <Popover placement="bottomRight" trigger="click" content={content}>
      <button
        type="button"
        className="account-menu-trigger"
        aria-label={actorText}
        data-testid="current-actor"
      >
        <Avatar className="account-menu-trigger__avatar" icon={hasProfile ? undefined : <UserOutlined />}>
          {hasProfile ? avatarLabel : null}
        </Avatar>
        <span className="sr-only">{actorText}</span>
      </button>
    </Popover>
  );

  if (!portalSelector) return trigger;
  return portalTarget ? createPortal(trigger, portalTarget) : null;
};

export default AccountMenuTrigger;
